import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { eventsKey, updateInterviewRoute } from '@features/events';
import axiosInstance from '@server/axiosInstance';
import { eventsInterviewKey } from '@features/enterpriseEvents';

type UseUpdateInterviewProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  interviewStartTime: number;
};

export const useUpdateInterview = ({
  setErrorText = () => { },
  interviewStartTime,
}: UseUpdateInterviewProps) => {
  const client = useQueryClient();

  const { mutate: updateInterview, isLoading: isUpdatingInterview } =
    useMutation({
      mutationFn: (variables: {
        interview_id: number;
        start_time: number;
        end_time: number;
        eventDate: string;
      }) =>
        axiosInstance
          .post(updateInterviewRoute, variables)
          .then((res) => res.data),
      onSuccess: (data, req) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries(eventsKey);
          client.invalidateQueries(eventsInterviewKey);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    updateInterview,
    isUpdatingInterview,
  };
};
